"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpEnqueueActionsSource = void 0;
const core_types_1 = require("@dqm/core-types");
const http_polling_source_1 = require("@dqm/http-polling-source");
const queue_actions_1 = require("@dqm/queue-actions");
class HttpEnqueueActionsSource extends http_polling_source_1.HttpPollingSource {
    constructor(fetchUrl, options = {}) {
        if (options.pollInterval === undefined) {
            options.pollInterval = 60 * 1000;
        }
        super(fetchUrl, options);
    }
    formatResponse(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(0, queue_actions_1.isActionList)(data)) {
                throw new core_types_1.InvalidResponseError();
            }
            return data;
        });
    }
}
exports.HttpEnqueueActionsSource = HttpEnqueueActionsSource;
//# sourceMappingURL=HttpEnqueueActionsSource.js.map